import styled from 'styled-components';
import BackgroundLogo from "../../assets/images/back_logo.png";

const MyDiv = styled.div`

`;

export default MyDiv;
